(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  var form = document.getElementById('FacetForm');
  if (form) {
    form.addEventListener('change', function () {
      form.submit();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('[data-bundle-check]').forEach(function (box) {
      box.addEventListener('change', function () {
        var form = box.closest('form');
        var input = form.querySelector('[data-bundle-input="' + box.dataset.bundleCheck + '"]');
        if (input) input.disabled = !box.checked;

        var cents = 0;
        form.querySelectorAll('.buyopt__row').forEach(function (row) {
          var check = row.querySelector('input[type="checkbox"]');
          if (check && !check.checked) return;
          cents += parseInt(row.querySelector('[data-bundle-cents]').dataset.bundleCents, 10);
        });
        var totalEl = form.querySelector('[data-bundle-total]');
        var symbol = totalEl.textContent.replace(/[0-9.,\s]/g, '');
        totalEl.textContent = symbol + (cents / 100).toFixed(2).replace('.', ',');
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  document.querySelectorAll('[data-recommendations]').forEach(function (root) {
    fetch(root.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh) root.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });

  } catch(e) { console.error(e); }
})();
})();
